<cs-header>
  <cs-header-title>{{ mode===Mode.Select ? LL.equipment.titles.changeEquipment() : LL.equipment.titles.equipment() }}</cs-header-title>
</cs-header>

<cs-content>
  <!-- Top Controls -->
  <div class="controls-row">
    <!-- Category Dropdown (Select mode only) -->
    @if (mode === Mode.Select) {
      <!-- [ariaLabel] names the dropdown: the search input shares this row, so there is no row
           text the select can take its name from -->
      <cs-select class="category-select" [ariaLabel]="LL.equipment.labels.filters()" [(value)]="selectedCategoryId"
        (selectionChange)="handleCategoryChange($event)" [placeholder]="LL.equipment.labels.filters()">
        <cs-select-option [value]="''" [label]="LL.equipment.filters.all()"></cs-select-option>
        <!-- category.name is a localized equipment-template display name (already
             routed through LL) -->
        @for (category of availableCategories; track category.id) {
          <cs-select-option [value]="category.id" [label]="category.name | untranslated">
            @if (category.id === exerciseTemplateId) {
              <cs-badge color="gray">{{ LL.equipment.filters.suggested() }}</cs-badge>
            }
          </cs-select-option>
        }
      </cs-select>
    }

    <!-- Search Input -->
    <cs-input #searchInput class="search-input" iconName="search" autocomplete="off" [(value)]="searchText"
      type="text" name="searchText" inputmode="search" [placeholder]="LL.equipment.placeholders.search()"
      (input)="handleSearchChanged()" />

    <!-- Create Equipment Link -->
    <cs-button tertiary icon="add" (click)="handleCreateButton($event)">{{ LL.equipment.buttons.createEquipment() }}</cs-button>
  </div>

  <!-- Filter Badges (Browse mode only) -->
  @if (mode === Mode.Browse) {
    <div class="filter-badges">
      <cs-badge [ngClass]="{ active: filterShowTemplates }" (click)="handleShowTemplates()">
        {{ LL.equipment.filters.showTemplates() }}
      </cs-badge>
      <cs-badge [ngClass]="{ active: filterShowMine }" (click)="handleShowMine()">
        {{ LL.equipment.filters.showMine() }}
      </cs-badge>
    </div>
  }

  <!-- Equipment List -->
  <div class="equipment-list-container">
    <!-- Loading Spinner -->
    @if (showSpinner) {
      <div class="loading-spinner">
        <cs-spinner></cs-spinner>
      </div>
    }

    <!-- Equipment Table -->
    @if (!showSpinner) {
      <cs-radio-group [(selected)]="selectedItemId">
        <cs-table class="equipment-table">
          @for (item of filteredEquipment; track item.id; let itemIndex = $index) {
            <cs-table-row clickable
              (rowClick)="handleRowClick(item)" id="item-{{itemIndex}}">
              <cs-table-cell class="radio-cell">
                <cs-radio [value]="item.id"></cs-radio>
              </cs-table-cell>
              <cs-table-cell class="info-cell">
                <div class="equipment-header">
                  <div class="equipment-name">{{ item.equipment.name }}{{ item.isTemplate ? (' ' + LL.equipment.labels.template()) : '' }}</div>
                  @if (getUsageCount(item) > 0) {
                    <cs-tooltip [text]="LL.equipment.labels.usedIn({exercises: generateEquipmentUsedByText(item)})" [hasCustomTrigger]="true" class="usage-count">
                      <span tooltip-trigger>
                        <cs-icon name="link"></cs-icon>
                        {{ getUsageCount(item) }}
                      </span>
                    </cs-tooltip>
                  }
                </div>
                <div class="equipment-description">{{ generateEquipmentDescription(item) }}</div>
              </cs-table-cell>
              <cs-table-cell class="actions-cell" align="right">
                <cs-icon-button icon="ellipsis-vertical" (click)="handleMoreOptions($event, item)"></cs-icon-button>
              </cs-table-cell>
            </cs-table-row>
          }
        </cs-table>
      </cs-radio-group>
    }

    <!-- No Results Empty State -->
    @if (filteredEquipment.length === 0 && searchText.length > 0 && !showSpinner) {
      <cs-empty-state
        iconName="search"
        [title]="LL.equipment.emptyState.noResultsTitle()"
        [subtext]="LL.equipment.emptyState.noResultsSubtext()">
      </cs-empty-state>
    }

    <!-- Show Templates Suggestion -->
    @if (mode === Mode.Browse && !filterShowTemplates && numSearchMatchesHidden > 0) {
      <div class="show-more-hint">
        @if (numCustomEquipment === 0) {
          <p>{{ LL.equipment.messages.noEquipmentDefined() }}</p>
        }
        @if (numCustomEquipment > 0) {
          <p>{{ LL.equipment.messages.showingOnlyCustom({count:
          numSearchMatchesHidden}) }}</p>
        }
        <p>{{ LL.equipment.messages.wouldYouLike() }}
          <a (click)="handleShowTemplates()">{{ LL.equipment.links.showTemplates() }}</a>
          {{ LL.equipment.messages.toCreateEquipment() }}?
        </p>
      </div>
    }
  </div>
</cs-content>

<cs-page-action-buttons [showCancel]="mode === Mode.Select" (cancel)="handleCancelButtonClicked($event, ButtonType.Footer)">
  @if (mode === Mode.Select) {
    <cs-button medium primary [label]="LL.common.buttons.select()"
      [disabled]="!getSelectedItem() || isEquipmentIdTemplate(getSelectedItem())"
    (click)="handleAcceptButtonClicked($event, ButtonType.Footer)"></cs-button>
  }
</cs-page-action-buttons>
